import React from 'react'
import { func, object } from 'prop-types'

import Input from 'coact/Input'
import Select from 'coact/Select'

import DegreeInput from './DegreeInput'
import CInput from './CInput'

function LensSpec (props) {
  const { spliter, style } = props
  const getChildProps = spliter(props)

  return (
    <div className={style['model-spec']}>
      <div>
        <Select {...getChildProps('eye')} style={{ textAlign: 'left' }} placeholder="LR" />
      </div>
      <span>S:</span>
      <div><DegreeInput {...getChildProps('s')} /></div>
      <span>C:</span>
      <div><CInput {...getChildProps('c')} /></div>
      <span>A:</span>
      <div><Input type="number" {...getChildProps('a')} /></div>
      <span>ADD:</span>
      <div><DegreeInput {...getChildProps('add')} /></div>
    </div>
  )
}

LensSpec.propTypes = {
  spliter: func.isRequired,
  style: object.isRequired,
}

export default LensSpec



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/LensSpec/LensSpec.jsx